import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import { isMobile } from "react-device-detect";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import Volume from "./Volume";
import SicboRules from "./pop-up/sicbo-rules.jsx";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import SicboResult from "../../client/tp-studio/tp-result/SicboResult.jsx";


import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Sicbo() {
  const dispatch = useDispatch();

  useEffect(() => {
    document.documentElement.classList.add("roulette-bg-black");
    document.documentElement.classList.add("h-100");

    return () => {
      document.documentElement.classList.remove("roulette-bg-black");
      document.documentElement.classList.remove("h-100");
    };
  }, []);

  let rateVal = "500,000";
  const [showRules, setShowRules] = useState(false);
  const [stakeLimit, setStakeLimit] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);

  const [odds, setOdds] = useState("");
  const [even, setEven] = useState("");
  const [anyTriple, setAnyTriple] = useState("");

  const [totalHighSmall, setTotalHighSmall] = useState("");
  const [totalHighBig, setTotalHighBig] = useState("");
  const [totalHighTripple, setTotalHighTripple] = useState("");

  const [anyTrippleAnyTripple, setAnyTrippleAnyTripple] = useState("");
  const [anyTrippleNoTripple, setAnyTrippleNoTripple] = useState("");

  const [tripple1, setTripple1] = useState(0);
  const [tripple2, setTripple2] = useState(0);
  const [tripple3, setTripple3] = useState(0);
  const [tripple4, setTripple4] = useState(0);
  const [tripple5, setTripple5] = useState(0);
  const [tripple6, setTripple6] = useState(0);
  const [trippleNoWinner, setTrippleNoWinner] = useState(0);

  const [allDiceTotalThree, setAllDiceTotalThree] = useState(0);
  const [allDiceTotalFour, setAllDiceTotalFour] = useState(0);
  const [allDiceTotalFive, setAllDiceTotalFive] = useState(0);
  const [allDiceTotalSix, setAllDiceTotalSix] = useState(0);
  const [allDiceTotalSeven, setAllDiceTotalSeven] = useState(0);
  const [allDiceTotalEight, setAllDiceTotalEight] = useState(0);
  const [allDiceTotalNine, setAllDiceTotalNine] = useState(0);
  const [allDiceTotalTen, setAllDiceTotalTen] = useState(0);
  const [allDiceTotalEleven, setAllDiceTotalEleven] = useState(0);
  const [allDiceTotalTweleve, setAllDiceTotalTweleve] = useState(0);
  const [allDiceTotalThirteen, setAllDiceTotalThirteen] = useState(0);
  const [allDiceTotalFourteen, setAllDiceTotalFourteen] = useState(0);
  const [allDiceTotalFifteen, setAllDiceTotalFifteen] = useState(0);
  const [allDiceTotalSixteen, setAllDiceTotalSixteen] = useState(0);
  const [allDiceTotalSeventeen, setAllDiceTotalSeventeen] = useState(0);
  const [allDiceTotalEighteen, setAllDiceTotalEighteen] = useState(0);

  const [oddsBook, setOddsBook] = useState(0);
  const [evenBook, setEvenBook] = useState(0);
  const [anyTripleBook, setAnyTripleBook] = useState(0);

  const [totalHighSmallBook, setTotalHighSmallBook] = useState(0);
  const [totalHighBigBook, setTotalHighBigBook] = useState(0);
  const [totalHighTrippleBook, setTotalHighTrippleBook] = useState(0);

  const [anyTrippleAnyTrippleBook, setAnyTrippleAnyTrippleBook] = useState(0);
  const [anyTrippleNoTrippleBook, setAnyTrippleNoTrippleBook] = useState(0);

  const [tripple1Book, setTripple1Book] = useState(0);
  const [tripple2Book, setTripple2Book] = useState(0);
  const [tripple3Book, setTripple3Book] = useState(0);
  const [tripple4Book, setTripple4Book] = useState(0);
  const [tripple5Book, setTripple5Book] = useState(0);
  const [tripple6Book, setTripple6Book] = useState(0);
  const [trippleNoWinnerBook, setTrippleNoWinnerBook] = useState(0);

  const [allDiceTotalThreeBook, setAllDiceTotalThreeBook] = useState(0);
  const [allDiceTotalFourBook, setAllDiceTotalFourBook] = useState(0);
  const [allDiceTotalFiveBook, setAllDiceTotalFiveBook] = useState(0);
  const [allDiceTotalSixBook, setAllDiceTotalSixBook] = useState(0);
  const [allDiceTotalSevenBook, setAllDiceTotalSevenBook] = useState(0);
  const [allDiceTotalEightBook, setAllDiceTotalEightBook] = useState(0);
  const [allDiceTotalNineBook, setAllDiceTotalNineBook] = useState(0);
  const [allDiceTotalTenBook, setAllDiceTotalTenBook] = useState(0);
  const [allDiceTotalElevenBook, setAllDiceTotalElevenBook] = useState(0);
  const [allDiceTotalTweleveBook, setAllDiceTotalTweleveBook] = useState(0);
  const [allDiceTotalThirteenBook, setAllDiceTotalThirteenBook] = useState(0);
  const [allDiceTotalFourteenBook, setAllDiceTotalFourteenBook] = useState(0);
  const [allDiceTotalFifteenBook, setAllDiceTotalFifteenBook] = useState(0);
  const [allDiceTotalSixteenBook, setAllDiceTotalSixteenBook] = useState(0);
  const [allDiceTotalSeventeenBook, setAllDiceTotalSeventeenBook] = useState(0);
  const [allDiceTotalEighteenBook, setAllDiceTotalEighteenBook] = useState(0);

  const [roundId, setRoundId] = useState(0);
  const [cardDesc, setCardDesc] = useState([]);
  const [resultDesc, setResultDesc] = useState("");
  const [result, setResult] = useState("");
  const [resultList, setResultList] = useState([]);

  const [lastStatus, setLastStatus] = useState(null);

  const [displayLoader, setDisplayLoader] = useState(true);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const lastEvtStatusRef = useRef(null);

  /* ================= DICE ANIMATION STATE ================= */
  const DICE_SIZE = 75;
  const HALF = DICE_SIZE / 2;
  const [dice1Value, setDice1Value] = useState(1);
  const [dice2Value, setDice2Value] = useState(1);
  const [dice3Value, setDice3Value] = useState(1);
  const [isRolling, setIsRolling] = useState(false);
  const [diceSettled, setDiceSettled] = useState(false);
  const diceRollTimerRef = useRef(null);
  const diceResultKeyRef = useRef("");

  const [resultData, setResultData] = useState([]);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "sicbo_virtual"
  });

  const payload = data?.data?.data;

  //console.log("data:", payload); // DO NOT REMOVE

  const payloadResult = data?.data?.result;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  //console.log("payloadResult:", payloadResult); // DO NOT REMOVE
  //console.log("inside payloadResult:", payloadResult); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */
  useEffect(() => {
    //console.log("Inside useEffect for payload change:", payload); // DO NOT REMOVE
    if (!payload) return;
    setDisplayLoader(false);

    updateUserData(data?.user);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setCardDesc([]);

      // Reset dice
      clearTimeout(diceRollTimerRef.current);
      diceResultKeyRef.current = "";
      setIsRolling(false);
      setDiceSettled(false);
      setDice1Value(Math.floor(Math.random() * 6) + 1);
      setDice2Value(Math.floor(Math.random() * 6) + 1);
      setDice3Value(Math.floor(Math.random() * 6) + 1);

      setOdds(0);
      setEven(0);
      setAnyTriple(0);
      setTotalHighSmall(0);
      setTotalHighBig(0);
      setTotalHighTripple(0);
      setAnyTrippleAnyTripple(0);
      setAnyTrippleNoTripple(0);
      setTripple1(0);
      setTripple2(0);
      setTripple3(0);
      setTripple4(0);
      setTripple5(0);
      setTripple6(0);
      setTrippleNoWinner(0);
      setAllDiceTotalThree(0);
      setAllDiceTotalFour(0);
      setAllDiceTotalFive(0);
      setAllDiceTotalSix(0);
      setAllDiceTotalSeven(0);
      setAllDiceTotalEight(0);
      setAllDiceTotalNine(0);
      setAllDiceTotalTen(0);
      setAllDiceTotalEleven(0);
      setAllDiceTotalTweleve(0);
      setAllDiceTotalThirteen(0);
      setAllDiceTotalFourteen(0);
      setAllDiceTotalFifteen(0);
      setAllDiceTotalSixteen(0);
      setAllDiceTotalSeventeen(0);
      setAllDiceTotalEighteen(0);

      setOddsBook(0);
      setEvenBook(0);
      setAnyTripleBook(0);
      setTotalHighSmallBook(0);
      setTotalHighBigBook(0);
      setTotalHighTrippleBook(0);
      setAnyTrippleAnyTrippleBook(0);
      setAnyTrippleNoTrippleBook(0);

      setTripple1Book(0);
      setTripple2Book(0);
      setTripple3Book(0);
      setTripple4Book(0);
      setTripple5Book(0);
      setTripple6Book(0);
      setTrippleNoWinnerBook(0);

      setAllDiceTotalThreeBook(0);
      setAllDiceTotalFourBook(0);
      setAllDiceTotalFiveBook(0);
      setAllDiceTotalSixBook(0);
      setAllDiceTotalSevenBook(0);
      setAllDiceTotalEightBook(0);
      setAllDiceTotalNineBook(0);
      setAllDiceTotalTenBook(0);
      setAllDiceTotalElevenBook(0);
      setAllDiceTotalTweleveBook(0);
      setAllDiceTotalThirteenBook(0);
      setAllDiceTotalFourteenBook(0);
      setAllDiceTotalFifteenBook(0);
      setAllDiceTotalSixteenBook(0);
      setAllDiceTotalSeventeenBook(0);
      setAllDiceTotalEighteenBook(0);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setRoundId(payload?.cat_mid);

    setOdds(payload?.b1);
    setEven(payload?.b2);
    setAnyTriple(0);

    setTotalHighSmall(payload?.b1);
    setTotalHighBig(payload?.b2);
    setTotalHighTripple(0);

    setAnyTrippleAnyTripple(payload?.b3);
    setAnyTrippleNoTripple(0);

    setTripple1(payload?.b4);
    setTripple2(payload?.b4);
    setTripple3(payload?.b4);
    setTripple4(payload?.b4);
    setTripple5(payload?.b4);
    setTripple6(payload?.b4);
    setTrippleNoWinner(0);

    setAllDiceTotalThree(0);
    setAllDiceTotalFour(payload?.b5);
    setAllDiceTotalFive(payload?.b6);
    setAllDiceTotalSix(payload?.b7);
    setAllDiceTotalSeven(payload?.b8);
    setAllDiceTotalEight(payload?.b9);
    setAllDiceTotalNine(payload?.b10);
    setAllDiceTotalTen(payload?.b10);
    setAllDiceTotalEleven(payload?.b10);
    setAllDiceTotalTweleve(payload?.b10);
    setAllDiceTotalThirteen(payload?.b9);
    setAllDiceTotalFourteen(payload?.b8);
    setAllDiceTotalFifteen(payload?.b7);
    setAllDiceTotalSixteen(payload?.b6);
    setAllDiceTotalSeventeen(payload?.b5);
    setAllDiceTotalEighteen(0);

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    // Animate dice when market closes and results are available
    if (
      payload?.evt_status === "CLOSED" &&
      payload?.c1 != null &&
      payload?.c2 != null &&
      payload?.c3 != null
    ) {
      const d1 = parseInt(payload.c1, 10);
      const d2 = parseInt(payload.c2, 10);
      const d3 = parseInt(payload.c3, 10);
      const facesOk = [d1, d2, d3].every((n) => n >= 1 && n <= 6);
      //console.log("Dice values from payload:", d1, d2, d3); // DO NOT REMOVE

      // Roll once per result. Later ticks of the same round must not restart it.
      const resultKey = `${payload.cat_mid}:${d1}-${d2}-${d3}`;
      if (facesOk && diceResultKeyRef.current !== resultKey) {
        diceResultKeyRef.current = resultKey;
        setIsRolling(true);
        setDiceSettled(false);
        clearTimeout(diceRollTimerRef.current);
        diceRollTimerRef.current = setTimeout(() => {
          setDice1Value(d1);
          setDice2Value(d2);
          setDice3Value(d3);
          setIsRolling(false);
          setDiceSettled(true);
        }, 3000); // matches CSS sicboRoll animation duration
      }
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= SINGLE CARD UPDATE + FLIP ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (lastEvtStatusRef.current === payload.evt_status) return;
    lastEvtStatusRef.current = payload.evt_status;

    if (payload?.c1) {
      setShownCard(payload.c1);
    }

    if (payload.evt_status === "CLOSED") {
      setShouldFlip(true);
    } else {
      setShouldFlip(false);
    }
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= WINNER COMPUTATION ================= */
  const diceTotal = dice1Value + dice2Value + dice3Value;
  const isTriple = dice1Value === dice2Value && dice2Value === dice3Value;
  const showWinner = payload?.evt_status === "CLOSED" && diceSettled;

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid,
    marketVal
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: marketVal,
      game_type: 7,
      game_name: "sicbo_virtual",
      market_type: marketTypeVal,
      marketVal: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit??data?.myBetLimit?.figure));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "sicbo_virtual"
    });

    setPlacedBets(res.data);
  }

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "sicbo_virtual"
    });

    //console.log("res.length->", res.data.length);
    if (res.data?.length > 0) {
      for (let tt = 0; tt < res.data?.length; tt++) {
        let bookobj = res.data[tt];

        if (bookobj.market_type == 1) {
          setOddsBook(bookobj.rnr1s);
          setEvenBook(bookobj.rnr2s);
          setAnyTripleBook(bookobj.rnr3s);
        } else if (bookobj.market_type == 2) {
          setTotalHighSmallBook(bookobj.rnr1s);
          setTotalHighBigBook(bookobj.rnr2s);
          setTotalHighTrippleBook(bookobj.rnr3s);
        } else if (bookobj.market_type == 3) {
          setAnyTrippleAnyTrippleBook(bookobj.rnr1s);
          setAnyTrippleNoTrippleBook(bookobj.rnr2s);
        } else if (bookobj.market_type == 4) {
          setTripple1Book(0);
          setTripple2Book(0);
          setTripple3Book(0);
          setTripple4Book(0);
          setTripple5Book(0);
          setTripple6Book(0);
          setTrippleNoWinnerBook(0);
        } else if (bookobj.market_type == 5) {
          setAllDiceTotalThreeBook(bookobj.rnr1s);
          setAllDiceTotalFourBook(bookobj.rnr2s);
          setAllDiceTotalFiveBook(bookobj.rnr3s);
          setAllDiceTotalSixBook(bookobj.rnr4s);
          setAllDiceTotalSevenBook(bookobj.rnr5s);
          setAllDiceTotalEightBook(bookobj.rnr6s);
          setAllDiceTotalNineBook(bookobj.rnr7s);
          setAllDiceTotalTenBook(bookobj.rnr8s);
          setAllDiceTotalElevenBook(bookobj.rnr9s);
          setAllDiceTotalTweleveBook(bookobj.rnr10s);
          setAllDiceTotalThirteenBook(bookobj.rnr11s);
          setAllDiceTotalFourteenBook(bookobj.rnr12s);
          setAllDiceTotalFifteenBook(bookobj.rnr13s);
          setAllDiceTotalSixteenBook(bookobj.rnr14s);
          setAllDiceTotalSeventeenBook(bookobj.rnr15s);
          setAllDiceTotalEighteenBook(bookobj.rnr16s);
        }
      }
    }
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  /* ================= SICBO DICE INLINE STYLES ================= */
  const sicboDiceStyles = `
    .sicbo-dicegame {
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      position: relative;
      width: auto;
      height: auto;
    }
    .sicbo-container-row1 {
      display: flex;
      flex-wrap: wrap;
      gap:10px;
      justify-content: center;
      align-items: center;
      margin: 10px;
      margin-top: 40px;
      perspective: 600px;
      width: 100%;
    }
    
    .sicbo-container-row2 {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px;
      perspective: 600px;
      width: 100%;
    }
    .sicbo-dice {
      margin: 5px 30px;
      width: ${DICE_SIZE}px;
      height: ${DICE_SIZE}px;
      position: relative;
      transform-style: preserve-3d;
      transition: transform 0.4s ease-out;
    }
    .sicbo-side {
      backface-visibility: hidden;
      -webkit-backface-visibility: hidden;
    }
    .sicbo-dice.sicbo-rolling {
      animation: sicboRoll 3s ease-in-out;
      transition: none !important;
    }
    .sicbo-side {
      position: absolute;
      background-color: #fff;
      border-radius: 5px;
      width: ${DICE_SIZE}px;
      height: ${DICE_SIZE}px;
      top: 0;
      left: 0;
      border: none;
      box-sizing: border-box;
      box-shadow: none;
    }
    .sicbo-side:nth-child(1) { transform: translateZ(${HALF}px); }
    .sicbo-side:nth-child(2) { transform: rotateY(180deg) translateZ(${HALF}px); }
    .sicbo-side:nth-child(3) { transform: rotateY(-90deg) translateZ(${HALF}px); }
    .sicbo-side:nth-child(4) { transform: rotateX(90deg) translateZ(${HALF}px); }
    .sicbo-side:nth-child(5) { transform: rotateX(-90deg) translateZ(${HALF}px); }
    .sicbo-side:nth-child(6) { transform: rotateY(90deg) translateZ(${HALF}px); }
    .sicbo-dot {
      position: absolute;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #ef233c;
      box-shadow: inset 2px 2px #d90429;
    }
    /* dot positions */
    .sicbo-two-1, .sicbo-three-1, .sicbo-four-1, .sicbo-five-1, .sicbo-six-1 { top: 10%; left: 10%; }
    .sicbo-four-3, .sicbo-five-3, .sicbo-six-4 { top: 10%; left: 70%; }
    .sicbo-one-1, .sicbo-three-2, .sicbo-five-5 { top: 39%; left: 41%; }
    .sicbo-four-2, .sicbo-five-2, .sicbo-six-3 { top: 75%; left: 10%; }
    .sicbo-two-2, .sicbo-three-3, .sicbo-four-4, .sicbo-five-4, .sicbo-six-6 { top: 75%; left: 71%; }
    .sicbo-six-2 { top: 43%; left: 10%; }
    .sicbo-six-5 { top: 40%; left: 70%; }
    /* show faces */
    .sicbo-show1 { transform: rotateX(0deg) rotateY(0deg); }
    .sicbo-show2 { transform: rotateX(0deg) rotateY(180deg); }
    .sicbo-show3 { transform: rotateY(90deg); }
    .sicbo-show4 { transform: rotateX(-90deg); }
    .sicbo-show5 { transform: rotateX(90deg); }
    .sicbo-show6 { transform: rotateY(-90deg); }
    @keyframes sicboRoll {
      0%   { transform: rotateX(0deg)   rotateY(0deg)   rotateZ(0deg); }
      25%  { transform: rotateX(180deg) rotateY(180deg) rotateZ(0deg); }
      50%  { transform: rotateX(360deg) rotateY(0deg)   rotateZ(180deg); }
      75%  { transform: rotateX(180deg) rotateY(360deg) rotateZ(180deg); }
      100% { transform: rotateX(360deg) rotateY(360deg) rotateZ(360deg); }
    }
    .sicbo-overlayClass {
    position: absolute !important;
    height: 100% !important;
    width: 100% !important;
    justify-content: center;
    font-family: monospace;
    top: 0;
    left: 0;
    width: 90%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(10px);
    justify-content: center;
    align-items: center;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
  `;

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "sicbo_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="aviator-scope aviator-bg-black">
      <style>{sicboDiceStyles}</style>
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          <div
                            className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45"
                            style={{ position: "relative", zIndex: 1000 }}
                          >
                            <div className="col-6 col-md-6 titlebarname mt-2">
                              <p>&nbsp;SIC-BO </p>
                            </div>

                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                                <SicboRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none",
                            color: "white"
                          }}
                        >
                          <div>
                            <div className="cards-layout blackjack">
                              <div className="col-12 timerDiv2">
                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {payload?.evt_status === "OPEN" && (
                                    <div className="sicbo-overlayClass">
                                      <div className="overlay-text">
                                        New Round
                                      </div>
                                      <div className="overlay-text">
                                        Betting Open
                                      </div>
                                    </div>
                                  )}
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          326
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none",
                                    position: "relative",
                                    zIndex: 1000
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div
                                    className="base-timer"
                                    style={{ right: "0" }}
                                  >
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                                    M 50, 50
                                                    m -45, 0
                                                    a 45,45 0 1,0 90,0
                                                    a 45,45 0 1,0 -90,0
                                                  "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {payload?.left_time == 1
                                        ? 0
                                        : payload?.left_time}
                                    </span>
                                  </div>
                                </div>

                                <div
                                  className="sicbo-dicegame"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none",
                                    position: "relative"
                                  }}
                                >
                                  <div className="sicbo-container-row1">
                                    <div
                                      id="dice1"
                                      className={`sicbo-dice ${isRolling
                                          ? "sicbo-rolling"
                                          : `sicbo-show${dice1Value}`
                                        }`}
                                    >
                                      <div className="sicbo-side">
                                        <div className="sicbo-dot sicbo-one-1"></div>
                                      </div>
                                      <div className="sicbo-side">
                                        <div className="sicbo-dot sicbo-two-1"></div>
                                        <div className="sicbo-dot sicbo-two-2"></div>
                                      </div>
                                      <div className="sicbo-side">
                                        <div className="sicbo-dot sicbo-three-1"></div>
                                        <div className="sicbo-dot sicbo-three-2"></div>
                                        <div className="sicbo-dot sicbo-three-3"></div>
                                      </div>
                                      <div className="sicbo-side">
                                        <div className="sicbo-dot sicbo-four-1"></div>
                                        <div className="sicbo-dot sicbo-four-2"></div>
                                        <div className="sicbo-dot sicbo-four-3"></div>
                                        <div className="sicbo-dot sicbo-four-4"></div>
                                      </div>
                                      <div className="sicbo-side">
                                        <div className="sicbo-dot sicbo-five-1"></div>
                                        <div className="sicbo-dot sicbo-five-2"></div>
                                        <div className="sicbo-dot sicbo-five-3"></div>
                                        <div className="sicbo-dot sicbo-five-4"></div>
                                        <div className="sicbo-dot sicbo-five-5"></div>
                                      </div>
                                      <div className="sicbo-side">
                                        <div className="sicbo-dot sicbo-six-1"></div>
                                        <div className="sicbo-dot sicbo-six-2"></div>
                                        <div className="sicbo-dot sicbo-six-3"></div>
                                        <div className="sicbo-dot sicbo-six-4"></div>
                                        <div className="sicbo-dot sicbo-six-5"></div>
                                        <div className="sicbo-dot sicbo-six-6"></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    id="dice2"
                                    className={`sicbo-dice ${isRolling
                                        ? "sicbo-rolling"
                                        : `sicbo-show${dice2Value}`
                                      }`}
                                  >
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-one-1"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-two-1"></div>
                                      <div className="sicbo-dot sicbo-two-2"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-three-1"></div>
                                      <div className="sicbo-dot sicbo-three-2"></div>
                                      <div className="sicbo-dot sicbo-three-3"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-four-1"></div>
                                      <div className="sicbo-dot sicbo-four-2"></div>
                                      <div className="sicbo-dot sicbo-four-3"></div>
                                      <div className="sicbo-dot sicbo-four-4"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-five-1"></div>
                                      <div className="sicbo-dot sicbo-five-2"></div>
                                      <div className="sicbo-dot sicbo-five-3"></div>
                                      <div className="sicbo-dot sicbo-five-4"></div>
                                      <div className="sicbo-dot sicbo-five-5"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-six-1"></div>
                                      <div className="sicbo-dot sicbo-six-2"></div>
                                      <div className="sicbo-dot sicbo-six-3"></div>
                                      <div className="sicbo-dot sicbo-six-4"></div>
                                      <div className="sicbo-dot sicbo-six-5"></div>
                                      <div className="sicbo-dot sicbo-six-6"></div>
                                    </div>
                                  </div>

                                  <div
                                    id="dice3"
                                    className={`sicbo-dice ${isRolling
                                        ? "sicbo-rolling"
                                        : `sicbo-show${dice3Value}`
                                      }`}
                                  >
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-one-1"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-two-1"></div>
                                      <div className="sicbo-dot sicbo-two-2"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-three-1"></div>
                                      <div className="sicbo-dot sicbo-three-2"></div>
                                      <div className="sicbo-dot sicbo-three-3"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-four-1"></div>
                                      <div className="sicbo-dot sicbo-four-2"></div>
                                      <div className="sicbo-dot sicbo-four-3"></div>
                                      <div className="sicbo-dot sicbo-four-4"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-five-1"></div>
                                      <div className="sicbo-dot sicbo-five-2"></div>
                                      <div className="sicbo-dot sicbo-five-3"></div>
                                      <div className="sicbo-dot sicbo-five-4"></div>
                                      <div className="sicbo-dot sicbo-five-5"></div>
                                    </div>
                                    <div className="sicbo-side">
                                      <div className="sicbo-dot sicbo-six-1"></div>
                                      <div className="sicbo-dot sicbo-six-2"></div>
                                      <div className="sicbo-dot sicbo-six-3"></div>
                                      <div className="sicbo-dot sicbo-six-4"></div>
                                      <div className="sicbo-dot sicbo-six-5"></div>
                                      <div className="sicbo-dot sicbo-six-6"></div>
                                    </div>
                                  </div>

                                  <Volume
                                    id="SicboSoundcontrol"
                                    style={{
                                      position: "absolute",
                                      right: 8,
                                      bottom: 8,
                                      zIndex: 100
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* Controls removed (auto mode) */}

                            <center
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                                <div className="buttons-div">
                                  {resultList &&
                                    Object.keys(resultList).map((idx) => (
                                      <button
                                        key={idx}
                                        className="video-button border-gradient-btn border-gradient-purple-btn"
                                      >
                                        {resultList[idx]}
                                      </button>
                                    ))}
                                </div>
                                <div className="round-div">
                                  <div className="label">Round ID:</div>
                                  <div className="id">{roundId}</div>
                                </div>
                              </div>
                            </center>

                            <div
                              className="section-blur"
                              style={{
                                display: activeTabIndex == 1 ? "" : "none"
                              }}
                            >
                              <div
                                class="tb-content"
                                style={{ background: "#fff" }}
                              >
                                <div class="market-titlebar">
                                  <p class="market-name">
                                    <span class="market-name-badge">
                                      <i class="market-name-icon">
                                        <img
                                          src="/assets/images/time-img.png"
                                          style={{
                                            filter: "invert(100%)",
                                            marginTop: "-8px",
                                            marginLeft: "-1px"
                                          }}
                                        />
                                      </i>
                                      <span>MATCH ODDS </span>
                                    </span>
                                  </p>
                                  <div class="market-overarround">
                                    <span></span>
                                    <strong>Back</strong>
                                  </div>
                                  <div class="market-overarround market-overarround-lay">
                                    <strong>Lay</strong>
                                  </div>
                                </div>
                                <div class="market-runners">
                                  <div class="runner-runner">
                                    <h3
                                      className={
                                        showWinner &&
                                          diceTotal % 2 !== 0 &&
                                          !isTriple
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b1Sucess"
                                    >
                                      <div class="runner-info">
                                        <span class="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: "0px",
                                                      fontSize: "16px",
                                                      fontWeight: "bold"
                                                    }}
                                                    class="clippable-spacer"
                                                  >
                                                    Odds
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        oddsBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        oddsBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(oddsBook)}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>

                                    <div class="price-row-box-new">
                                      <div
                                        class={
                                          isSuspended
                                            ? "runner-disabled2 suspendCls"
                                            : "runner-disabled2 suspendCls hides"
                                        }
                                      >
                                        {suspendedText}
                                      </div>
                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a
                                        class="price-price price-back mb-show span1details"
                                        data-teamname="Odds"
                                        data-bettype="b"
                                        market_type="1"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "Odds",
                                            "Odds",
                                            odds,
                                            1,
                                            1
                                          )
                                        }
                                      >
                                        <div
                                          id="rnr1"
                                          class="sus_cls"
                                          style={{ color: "#000" }}
                                        >
                                          <span class="price-odd odd" id="b1">
                                            {odds}
                                          </span>
                                          <span class="price-amount" id="rate1">
                                            {stakeLimit}
                                          </span>
                                        </div>
                                      </a>

                                      <a class="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>

                                  <div class="runner-runner">
                                    <h3
                                      className={
                                        showWinner &&
                                          diceTotal % 2 === 0 &&
                                          !isTriple
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b2Sucess"
                                    >
                                      <div class="runner-info">
                                        <span class="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: "0px",
                                                      fontSize: "16px",
                                                      fontWeight: "bold"
                                                    }}
                                                    class="clippable-spacer"
                                                  >
                                                    Even
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        evenBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        evenBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(evenBook)}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>

                                    <div class="price-row-box-new">
                                      <div
                                        class={
                                          isSuspended
                                            ? "runner-disabled2 suspendCls"
                                            : "runner-disabled2 suspendCls hides"
                                        }
                                      >
                                        {suspendedText}
                                      </div>
                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a
                                        class="price-price price-back mb-show span1details"
                                        data-teamname="Even"
                                        data-bettype="b"
                                        market_type="1"
                                        onClick={() =>
                                          showBetfairBetSlip(
                                            "b",
                                            "Even",
                                            "Even",
                                            even,
                                            1,
                                            1
                                          )
                                        }
                                      >
                                        <div id="rnr2" class="sus_cls">
                                          <span class="price-odd odd" id="b2">
                                            {even}
                                          </span>
                                          <span class="price-amount" id="rate2">
                                            {stakeLimit}
                                          </span>
                                        </div>
                                      </a>

                                      <a class="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>

                                  <div class="runner-runner">
                                    <h3
                                      className={
                                        showWinner && isTriple
                                          ? "runner-name sussesBg"
                                          : "runner-name"
                                      }
                                      id="b3Sucess"
                                    >
                                      <div class="runner-info">
                                        <span class="clippable runner-display-name">
                                          <table>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <h4
                                                    style={{
                                                      marginBottom: "0px",
                                                      fontSize: "16px",
                                                      fontWeight: "bold"
                                                    }}
                                                    class="clippable-spacer"
                                                  >
                                                    Any Triple
                                                  </h4>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <div
                                                    id="bstatus1"
                                                    style={{
                                                      float: "left",
                                                      display:
                                                        anyTripleBook !== 0
                                                          ? ""
                                                          : "none",
                                                      color:
                                                        anyTripleBook > 0
                                                          ? "green"
                                                          : "red",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    {formatTruncate(
                                                      anyTripleBook
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </span>
                                      </div>
                                    </h3>

                                    <div class="price-row-box-new">
                                      <div
                                        class={
                                          isSuspended
                                            ? "runner-disabled2 suspendCls"
                                            : "runner-disabled2 suspendCls hides"
                                        }
                                      >
                                        {suspendedText}
                                      </div>
                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-back whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-back mb-show susCard">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay ml-4 mb-show">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay whtBack">
                                        <div>&nbsp;</div>
                                      </a>

                                      <a class="price-price price-lay mr-4 whtBack">
                                        <div>&nbsp;</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style={{ height: "5px" }}></div>

                            {/* Footer */}

                            {/* Market Sections (unchanged) */}

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>TOTAL HIGH-LOW NUMBER</span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>

                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner &&
                                        diceTotal >= 4 &&
                                        diceTotal <= 10 &&
                                        !isTriple
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b4Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Small(4-10)
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      totalHighSmallBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      totalHighSmallBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    totalHighSmallBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Small"
                                      data-bettype="b"
                                      market_type="2"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Small",
                                          "Small",
                                          totalHighSmall,
                                          2,
                                          2
                                        )
                                      }
                                    >
                                      <div id="rnr4" class="sus_cls">
                                        <span class="price-odd odd" id="b4">
                                          {totalHighSmall}
                                        </span>
                                        <span class="price-amount" id="rate4">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner &&
                                        diceTotal >= 11 &&
                                        diceTotal <= 17 &&
                                        !isTriple
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b5Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Big(11-17)
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      totalHighBigBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      totalHighBigBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    totalHighBigBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Big"
                                      data-bettype="b"
                                      market_type="2"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Big",
                                          "Big",
                                          totalHighBig,
                                          2,
                                          2
                                        )
                                      }
                                    >
                                      <div id="rnr5" class="sus_cls">
                                        <span class="price-odd odd" id="b5">
                                          {totalHighBig}
                                        </span>
                                        <span class="price-amount" id="rate5">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b6Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Any Tripple
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      totalHighTrippleBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      totalHighTrippleBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    totalHighTrippleBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back mb-show susCard">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style={{ height: "5px" }}></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>Any Tripple</span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b7Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Any Tripple
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      anyTrippleAnyTrippleBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      anyTrippleAnyTrippleBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    anyTrippleAnyTrippleBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Any Tripple"
                                      data-bettype="b"
                                      market_type="3"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Any Tripple",
                                          "Any Tripple",
                                          anyTrippleAnyTripple,
                                          3,
                                          3
                                        )
                                      }
                                    >
                                      <div id="rnr7" class="sus_cls">
                                        <span class="price-odd odd" id="b7">
                                          {anyTrippleAnyTripple}
                                        </span>
                                        <span class="price-amount" id="rate7">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && !isTriple
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b8Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  No Tripple
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      anyTrippleNoTrippleBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      anyTrippleNoTrippleBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    anyTrippleNoTrippleBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back mb-show susCard">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style={{ height: "5px" }}></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>Tripple</span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple && dice1Value === 1
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b9Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  1+1+1
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tripple1Book !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tripple1Book > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tripple1Book)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tripple 1"
                                      data-bettype="b"
                                      market_type="4"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tripple 1",
                                          "Tripple 1",
                                          tripple1,
                                          4,
                                          4
                                        )
                                      }
                                    >
                                      <div id="rnr9" class="sus_cls">
                                        <span class="price-odd odd" id="b9">
                                          {tripple1}
                                        </span>
                                        <span class="price-amount" id="rate9">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple && dice1Value === 2
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b10Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  2+2+2
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tripple2Book !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tripple2Book > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tripple2Book)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tripple 2"
                                      data-bettype="b"
                                      market_type="4"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tripple 2",
                                          "Tripple 2",
                                          tripple2,
                                          4,
                                          4
                                        )
                                      }
                                    >
                                      <div id="rnr10" class="sus_cls">
                                        <span class="price-odd odd" id="b10">
                                          {tripple2}
                                        </span>
                                        <span class="price-amount" id="rate10">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple && dice1Value === 3
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b11Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  3+3+3
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tripple3Book !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tripple3Book > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tripple3Book)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tripple 3"
                                      data-bettype="b"
                                      market_type="4"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tripple 3",
                                          "Tripple 3",
                                          tripple3,
                                          4,
                                          4
                                        )
                                      }
                                    >
                                      <div id="rnr11" class="sus_cls">
                                        <span class="price-odd odd" id="b11">
                                          {tripple3}
                                        </span>
                                        <span class="price-amount" id="rate11">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple && dice1Value === 4
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b12Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  4+4+4
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tripple4Book !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tripple4Book > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tripple4Book)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tripple 4"
                                      data-bettype="b"
                                      market_type="4"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tripple 4",
                                          "Tripple 4",
                                          tripple4,
                                          4,
                                          4
                                        )
                                      }
                                    >
                                      <div id="rnr12" class="sus_cls">
                                        <span class="price-odd odd" id="b12">
                                          {tripple4}
                                        </span>
                                        <span class="price-amount" id="rate12">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple && dice1Value === 5
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b13Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  5+5+5
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tripple5Book !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tripple5Book > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tripple5Book)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tripple 5"
                                      data-bettype="b"
                                      market_type="4"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tripple 5",
                                          "Tripple 5",
                                          tripple5,
                                          4,
                                          4
                                        )
                                      }
                                    >
                                      <div id="rnr13" class="sus_cls">
                                        <span class="price-odd odd" id="b13">
                                          {tripple5}
                                        </span>
                                        <span class="price-amount" id="rate13">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && isTriple && dice1Value === 6
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b14Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  6+6+6
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      tripple6Book !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      tripple6Book > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(tripple6Book)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tripple 6"
                                      data-bettype="b"
                                      market_type="4"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tripple 6",
                                          "Tripple 6",
                                          tripple5,
                                          4,
                                          4
                                        )
                                      }
                                    >
                                      <div id="rnr14" class="sus_cls">
                                        <span class="price-odd odd" id="b14">
                                          {tripple6}
                                        </span>
                                        <span class="price-amount" id="rate14">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && !isTriple
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b15Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  No Winner
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      trippleNoWinnerBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      trippleNoWinnerBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    trippleNoWinnerBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back mb-show susCard">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div style={{ height: "5px" }}></div>

                            <div
                              class="tb-content"
                              style={{ background: "#fff" }}
                            >
                              <div class="market-titlebar">
                                <p class="market-name">
                                  <span class="market-name-badge">
                                    <i class="market-name-icon">
                                      <img
                                        src="/assets/images/time-img.png"
                                        style={{
                                          filter: "invert(100%)",
                                          marginTop: "-8px",
                                          marginLeft: "-1px"
                                        }}
                                      />
                                    </i>
                                    <span>ALL DICE TOTAl</span>
                                  </span>
                                </p>
                                <div class="market-overarround">
                                  <span></span>
                                  <strong>Back</strong>
                                </div>
                                <div class="market-overarround market-overarround-lay">
                                  <strong>Lay</strong>
                                </div>
                              </div>
                              <div class="market-runners">
                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 3
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b16Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Three
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalThreeBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalThreeBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalThreeBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back mb-show susCard">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 4
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b17Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Four
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalFourBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalFourBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalFourBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Four"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Four",
                                          "Four",
                                          allDiceTotalFour,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr17" class="sus_cls">
                                        <span class="price-odd odd" id="b17">
                                          {allDiceTotalFour}
                                        </span>
                                        <span class="price-amount" id="rate17">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 5
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b18Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Five
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalFiveBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalFiveBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalFiveBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Five"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Five",
                                          "Five",
                                          allDiceTotalFive,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr18" class="sus_cls">
                                        <span class="price-odd odd" id="b18">
                                          {allDiceTotalFive}
                                        </span>
                                        <span class="price-amount" id="rate18">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 6
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b19Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Six
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalSixBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalSixBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalSixBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Six"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Six",
                                          "Six",
                                          allDiceTotalSix,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr19" class="sus_cls">
                                        <span class="price-odd odd" id="b19">
                                          {allDiceTotalSix}
                                        </span>
                                        <span class="price-amount" id="rate19">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 7
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b20Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Seven
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalSevenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalSevenBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalSevenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Seven"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Seven",
                                          "Seven",
                                          allDiceTotalSeven,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr20" class="sus_cls">
                                        <span class="price-odd odd" id="b20">
                                          {allDiceTotalSeven}
                                        </span>
                                        <span class="price-amount" id="rate20">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 8
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b21Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Eight
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalEightBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalEightBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalEightBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Eight"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Eight",
                                          "Eight",
                                          allDiceTotalEight,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr21" class="sus_cls">
                                        <span class="price-odd odd" id="b21">
                                          {allDiceTotalEight}
                                        </span>
                                        <span class="price-amount" id="rate21">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 9
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b22Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Nine
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalNineBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalNineBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalNineBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Nine"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Nine",
                                          "Nine",
                                          allDiceTotalNine,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr22" class="sus_cls">
                                        <span class="price-odd odd" id="b22">
                                          {allDiceTotalNine}
                                        </span>
                                        <span class="price-amount" id="rate22">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 10
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b23Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Ten
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalTenBook !== 0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalTenBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalTenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Ten"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Ten",
                                          "Ten",
                                          allDiceTotalTen,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr23" class="sus_cls">
                                        <span class="price-odd odd" id="b23">
                                          {allDiceTotalTen}
                                        </span>
                                        <span class="price-amount" id="rate23">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 11
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b24Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Eleven
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalElevenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalElevenBook > 0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalElevenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Eleven"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Eleven",
                                          "Eleven",
                                          allDiceTotalEleven,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr24" class="sus_cls">
                                        <span class="price-odd odd" id="b24">
                                          {allDiceTotalEleven}
                                        </span>
                                        <span class="price-amount" id="rate24">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 12
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b25Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Tweleve
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalTweleveBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalTweleveBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalTweleveBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Tweleve"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Tweleve",
                                          "Tweleve",
                                          allDiceTotalTweleve,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr25" class="sus_cls">
                                        <span class="price-odd odd" id="b25">
                                          {allDiceTotalTweleve}
                                        </span>
                                        <span class="price-amount" id="rate25">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 13
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b26Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Thirteen
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalThirteenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalThirteenBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalThirteenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Thirteen"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Thirteen",
                                          "Thirteen",
                                          allDiceTotalThirteen,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr26" class="sus_cls">
                                        <span class="price-odd odd" id="b26">
                                          {allDiceTotalThirteen}
                                        </span>
                                        <span class="price-amount" id="rate26">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 14
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b27Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Fourteen
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalFourteenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalFourteenBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalFourteenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Fourteen"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Fourteen",
                                          "Fourteen",
                                          allDiceTotalFourteen,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr27" class="sus_cls">
                                        <span class="price-odd odd" id="b27">
                                          {allDiceTotalFourteen}
                                        </span>
                                        <span class="price-amount" id="rate27">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 15
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b28Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Fifteen
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalFifteenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalFifteenBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalFifteenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Fifteenen"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Fifteenen",
                                          "Fifteenen",
                                          allDiceTotalFifteen,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr28" class="sus_cls">
                                        <span class="price-odd odd" id="b28">
                                          {allDiceTotalFifteen}
                                        </span>
                                        <span class="price-amount" id="rate28">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 16
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b29Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Sixteen
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalSixteenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalSixteenBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalSixteenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Sixteen"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Sixteen",
                                          "Sixteen",
                                          allDiceTotalSixteen,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr29" class="sus_cls">
                                        <span class="price-odd odd" id="b29">
                                          {allDiceTotalSixteen}
                                        </span>
                                        <span class="price-amount" id="rate29">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 17
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b30Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Seventeen
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalSeventeenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalSeventeenBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalSeventeenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a
                                      class="price-price price-back mb-show span1details"
                                      data-teamname="Seventeen"
                                      data-bettype="b"
                                      market_type="5"
                                      onClick={() =>
                                        showBetfairBetSlip(
                                          "b",
                                          "Seventeen",
                                          "Seventeen",
                                          allDiceTotalSeventeen,
                                          5,
                                          5
                                        )
                                      }
                                    >
                                      <div id="rnr30" class="sus_cls">
                                        <span class="price-odd odd" id="b30">
                                          {allDiceTotalSeventeen}
                                        </span>
                                        <span class="price-amount" id="rate30">
                                          {stakeLimit}
                                        </span>
                                      </div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>

                                <div class="runner-runner">
                                  <h3
                                    className={
                                      showWinner && diceTotal === 18
                                        ? "runner-name sussesBg"
                                        : "runner-name"
                                    }
                                    id="b31Sucess"
                                  >
                                    <div class="runner-info">
                                      <span class="clippable runner-display-name">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h4
                                                  style={{
                                                    marginBottom: "0px",
                                                    fontSize: "16px",
                                                    fontWeight: "bold"
                                                  }}
                                                  class="clippable-spacer"
                                                >
                                                  Eighteen
                                                </h4>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div
                                                  id="bstatus1"
                                                  style={{
                                                    float: "left",
                                                    display:
                                                      allDiceTotalEighteenBook !==
                                                        0
                                                        ? ""
                                                        : "none",
                                                    color:
                                                      allDiceTotalEighteenBook >
                                                        0
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: 600
                                                  }}
                                                >
                                                  {formatTruncate(
                                                    allDiceTotalEighteenBook
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </span>
                                    </div>
                                  </h3>

                                  <div class="price-row-box-new">
                                    <div
                                      class={
                                        isSuspended
                                          ? "runner-disabled2 suspendCls"
                                          : "runner-disabled2 suspendCls hides"
                                      }
                                    >
                                      {suspendedText}
                                    </div>
                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-back mb-show susCard">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay ml-4 mb-show">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay whtBack">
                                      <div>&nbsp;</div>
                                    </a>

                                    <a class="price-price price-lay mr-4 whtBack">
                                      <div>&nbsp;</div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: activeTabIndex == 2 ? "" : "none",
                            color: "white"
                          }}
                        >
                          <SicboResult resultData={resultData} />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 no-padding-mobile">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);
                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>{displayRunnerName(bet.rnr)} - ({bet.cat_mid})</td>
                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
            .sus_cls{
              color:#000000;
            }
            .row {
              margin-left: 0 !important;
            }
            .player-scope .table-player .player {
              width: 210px !important;
            }
            .player-scope .table-player {
              gap: 9px !important;
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              height: auto !important;
              min-height: auto !important;
            }
            .player-scope .table-player .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            @media (min-width:992px){
              .cards-layout.blackjack {
                min-height: 240px;
              }
              .volume-wrapper {
                margin-top: -30px;
              }
            }  
            /* mobile */  
            @media (max-width: 576px) {
              .cards-layout.blackjack {
                min-height: 120px !important;
                width: 100% !important;
                padding: 0 !important;
              }
              .scroll-containeraviator img {
                width: 100% !important;
                height: auto !important;
                display: block;
              }
              .row {
                margin-left: 0 !important;
                margin-right: 0 !important;
              }
              .col-1,
              .col-6,
              .col-md-8,
              .col-md-6 {
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              .card-body {
                padding-left: 5px !important;
                padding-right: 5px !important;
              }
              .no-padding-mobile {
                padding-left: 0 !important;
                padding-right: 0 !important;
                margin-top: 6px;
              }
              .timerDiv2 {
                padding-left: 3px !important;
                padding-right: 3px !important;
              }


 
            }         
          `}
      </style>
    </div>
  );
}
